export default __webpack_public_path__ + "static/media/getitonGooglePlaySpanish.5d9a073b.png";